import styles from './TaskPriorityCell.module.scss';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import { ReactComponent as TaskPriorityMarkIcon } from '@work4all/assets/icons/task-actions/table/priority-mark.svg';

import { Task } from '@work4all/models/lib/Classes/Task.entity';

export enum TASKPRIORITY {
  'Niedrig' = 10,
  'NiedrigGelesen' = 0,
  'Normal' = 11,
  'NormalGelesen' = 1,
  'Hoch' = 12,
  'HochGelesen' = 2,
}

export type ITaskPriorityCellProps = {
  value: TASKPRIORITY;
  row: { original: Task };
};

export const TaskPriorityCell = (props: ITaskPriorityCellProps) => {
  const { value } = props;

  if (value === TASKPRIORITY.Niedrig || value === TASKPRIORITY.NiedrigGelesen) {
    return (
      <div className={styles.taskPriorityCellRoot}>
        <ArrowDownwardIcon sx={{ color: 'var(--brand02)' }} />
      </div>
    );
  }

  if (value === TASKPRIORITY.HochGelesen || value === TASKPRIORITY.Hoch) {
    return (
      <div className={styles.taskPriorityCellRoot}>
        <TaskPriorityMarkIcon />
      </div>
    );
  }

  return null;
};
